export const css = {
    root: '_3c4exSVk',
    question: '_18IdW60D',
    feedback: '_3E0Ig7gb',
    rationale: 'lrqDjBY-',
    fmi: '_3xNDuAUf',
    distractorBlock: '_3tF9yAqN',
    distractorFieldset: '_3jJs3JmA',
    distractorLegend: 'POBzMsuF',
    distractor: '_2u4WHd6q',
    distractorLabel: '_3hdWGqO4',
    distractorWithFlag: '_2LAJucfE',
    distractorHint: 'xZc4n5BG',
    actions: '_3Ifwo7Cr',
    oneaction: '_2ZBL1Yev',
    markblock: '_28c_G-mM',
    timerblock: '_3BQDLKNd',
    timer: '_3hWZJIT5',
    pressed: '_150DwvFg',
    primaryButton: '_3I8_tTDP',
    ' _key': 'apic-theme/apic/micro/quiz-widgets/mcquestion'
};
export default css;
